<template>
    <div>
        <b-form-group
        class="input-group-var-unitat"
        label="Unitat proveïdora"
        label-size="sm"
        label-for="input-var-unitat"
        label-cols="4"
        >
            <b-form-select
            required
            size="sm"
            id="input-var-unitat"
            class="var-unitat"
            v-model="unitat"
            :options="opcionsUnitat"
            @change="onUpdateUnitat"
            >
            </b-form-select>
        </b-form-group>
    </div>
</template>

<script>
import fitxesService from "@/services/FitxesService";
export default {
    name: "VariableUnitat",
    props: {
        initialValue:{
            required: true,
        },
        ambitSeleccionat: {
            required: true,
        },
        regioSeleccionat: {
            required: true,
        },
        entitatSeleccionat: {
            required: true,
        }
    },
    data(){
        return {
            codiVariable: "unitat",
            unitat: null,
            opcionsUnitat: [],
        };
    },
    computed: {
        returnValue(){
            let r = {codi: this.codiVariable};
            if(this.unitat != null){
                r.unitat = this.unitat
            }

            return r;
        },
    },
    methods: {
        onUpdateUnitat(value){
            const selected = this.opcionsUnitat.find(op => op.value === value);
            this.$emit("unitat-seleccionat", selected || { value, text: "" });
        },
        recuperarValorsUnitat(){
            const idEntitat = this.entitatSeleccionat?.value || this.entitatSeleccionat;
            console.log("idEntitat: "+idEntitat);
            if (!this.ambitSeleccionat || !this.regioSeleccionat || !idEntitat) return;
            fitxesService.getListUnitat(this.ambitSeleccionat, this.regioSeleccionat, idEntitat)
            .then(response => {
                this.opcionsUnitat = response.data.map(item => ({
                value: item.idUnitatProveidora,
                text: item.nomUnitatProveidora
                }));
                console.table(this.opcionsUnitat);
                this.unitat = null; // Reinicia el valor seleccionado
            })
            .catch(e => {
                console.log(e);
            });
        },
    },
    watch: {
        ambitSeleccionat() {
            this.unitat = null;
            this.recuperarValorsUnitat();
        },
        regioSeleccionat() {
            this.unitat = null;
            this.recuperarValorsUnitat();
        },
        entitatSeleccionat() {
            this.unitat = null;
            this.recuperarValorsUnitat();
        }
    },
    mounted(){
        if(this.initialValue != null){
            this.unitat = this.initialValue.valor;
        }
    }
}
</script>
<style>
.var-unitat {
  width: 250px;
}
.input-group-var-unitat .col {
  text-align: left;
}
</style>